// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2diz8","emails":"CreateEditClinics_emails__3rjKE","emailTagLabel":"CreateEditClinics_emailTagLabel__3-Nwh"};